import { api } from '@/api'
import type { ApiPaginationResponse } from '@/api/typings/response.typing'
import type { RoleItem } from '@/api/typings/roles.typing'

export function getRolesAction(page: number = 1): Promise<ApiPaginationResponse<RoleItem[]>> {
  return api.get<ApiPaginationResponse<RoleItem[]>>(`/roles?page=${page}`)
}
